import ProximaNovaTTF from '../../../../fonts/files/ProximaNovaTTF.ttf';
import ProximaNovaEOT from '../../../../fonts/files/ProximaNovaEOT.eot';
import ProximaNovaSVG from '../../../../fonts/files/ProximaNovaSVG.svg';
import ProximaNovaWOFF from '../../../../fonts/files/ProximaNovaWOFF.woff';
import JaguarBoldTTF from '../../../../fonts/files/JaguarBold.ttf';
import JaguarBoldEOT from '../../../../fonts/files/JaguarBold.eot';
import JaguarBoldSVG from '../../../../fonts/files/JaguarBold.svg';
import JaguarBoldWOFF from '../../../../fonts/files/JaguarBold.woff';
import BorisBlackBloxxTtf from '../../../../fonts/files/BorisBlackBloxx.ttf';
import BorisBlackBloxxWoff from '../../../../fonts/files/BorisBlackBloxx.woff';
import buildMuiTheme from '../../base-mui-theme';
import defaultBrandConstants from '../../brand-constants';
import buildBrandConstants from '../../../utils/buildBrandConstants';
import generateFontDeclaration from '../../../utils/generateFontDeclaration';
const buildMiniMyAccountBrandTheme = (brandConstantsOverride) => {
    const brandConstants = buildBrandConstants(defaultBrandConstants, brandConstantsOverride);
    const { fontSizes, colors } = brandConstants;
    const miniMyAccountBrandTheme = {
        ...buildMuiTheme(brandConstants, brandConstantsOverride?.typography),
        features: {},
        breakpoints: {
            values: brandConstants.screens,
        },
        components: {
            MuiScopedCssBaseline: {
                styleOverrides: {
                    root: `
          @font-face {
            font-family: 'ProximaNova';
            font-style: normal;
            font-display: swap;
            font-weight: 400;
            src:
              local('LandRoverWeb'),
              url(${ProximaNovaTTF}) format('ttf'),
              url(${ProximaNovaEOT}) format('eot'),
              url(${ProximaNovaSVG}) format('svg'),
              url(${ProximaNovaWOFF}) format('woff');
          }
          @font-face {
            font-family: 'JaguarBold';
            font-style: normal;
            font-display: swap;
            font-weight: 400;
            src:
              local('LandRoverWebBold'),
              url(${JaguarBoldTTF}) format('ttf'),
              url(${JaguarBoldEOT}) format('eot'),
              url(${JaguarBoldSVG}) format('svg'),
              url(${JaguarBoldWOFF}) format('woff');
          }
          @font-face {
            font-family: 'Boris-Black-Bloxx';
            font-style: normal;
            font-display: swap;
            font-weight: 400;
            src:
              local('Boris-Black-Bloxx'),
              url(${BorisBlackBloxxTtf}) format('ttf'),
              url(${BorisBlackBloxxWoff}) format('woff2'),
              url(${BorisBlackBloxxWoff}) format('woff');
          }
        `,
                    ...generateFontDeclaration(brandConstantsOverride?.typography),
                },
            },
            MuiMenu: {
                styleOverrides: {
                    root: {
                        top: '-16.4px',
                        left: '-3px',
                    },
                },
            },
            MuiButtonBase: {
                styleOverrides: {
                    root: {
                        fontSize: fontSizes.sm,
                    },
                },
            },
            MuiBreadcrumbs: {
                styleOverrides: {
                    ol: {
                        alignItems: 'baseline',
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontSize: fontSizes.sm,
                    },
                    contained: {
                        fontSize: fontSizes.sm,
                    },
                },
            },
            MuiSvgIcon: {
                styleOverrides: {
                    root: {
                        fontSize: fontSizes.lg,
                    },
                    fontSizeLarge: {
                        fontSize: fontSizes.xxl,
                    },
                },
            },
            MuiInputBase: {
                styleOverrides: {
                    root: {
                        height: 51,
                        borderColor: colors.light_grey,
                        '&:hover': {
                            borderColor: colors.third,
                        },
                        '& .Mui-focused': {
                            borderColor: colors.third,
                        },
                        '& fieldset': {
                            borderColor: 'inherit',
                        },
                    },
                },
            },
            MuiFormControlLabel: {
                styleOverrides: {
                    root: {
                        '& a': {
                            color: colors.primary,
                        },
                    },
                },
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        padding: 0,
                        maxHeight: 51,
                    },
                },
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        borderRadius: 0,
                    },
                },
            },
            MuiCard: {
                styleOverrides: {
                    root: {
                        boxShadow: 'none',
                    },
                },
            },
            MyAccount_Signup: {
                styleOverrides: {
                    cardContent: {
                        padding: 0,
                    },
                },
            },
            MyAccount_Signup_Header: {
                styleOverrides: {
                    root: {
                        padding: 0,
                    },
                    title: {
                        display: 'none',
                    },
                },
            },
            Signup_ButtonSubmit: {
                styleOverrides: {
                    submitButtonContainer: {
                        float: 'unset',
                        margin: 0,
                    },
                    submitButton: {
                        width: '100%',
                        maxWidth: 'unset',
                    },
                },
            },
            Signup_MiniWidgetButtonSubmit: {
                styleOverrides: {
                    submitButton: {
                        maxHeight: 40,
                    },
                },
            },
            MyAccount_GenericInput: {
                styleOverrides: {
                    root: {
                        marginRight: 0,
                        borderColor: colors.light_grey,
                        '&:hover': {
                            borderColor: colors.third,
                        },
                        '&.Mui-focused': {
                            borderColor: colors.third,
                        },
                        '& fieldset': {
                            borderColor: 'inherit',
                        },
                    },
                },
            },
            MuiFormLabel: {
                styleOverrides: {
                    asterisk: {
                        color: colors.primary,
                    },
                },
            },
            Login_Form: {
                styleOverrides: {
                    submitButton: {
                        borderRadius: 'unset',
                        maxWidth: '100%',
                        width: '100%',
                        justifyContent: 'center',
                        letterSpacing: 1.2,
                        fontWeight: 400,
                    },
                    forgotPasswordButton: {
                        maxWidth: '100%',
                        textDecoration: 'underline',
                        color: colors.secondary,
                        letterSpacing: 1.2,
                        fontWeight: 400,
                        padding: 0,
                        fontSize: fontSizes.xs,
                        marginBottom: 40,
                        '&:hover': {
                            backgroundColor: colors.white,
                        },
                        '& span': {
                            color: colors.primary,
                        },
                    },
                    subTitleContainer: {
                        display: 'flex',
                        justifyContent: 'space-between',
                    },
                    subTitle: {
                        fontSize: fontSizes.md,
                        marginBottom: '10px',
                    },
                    subTitleSecondary: {
                        color: colors.error,
                        fontSize: fontSizes.xxs,
                        alignSelf: 'center',
                    },
                },
            },
            Login_ControlledInput: {
                styleOverrides: {
                    label: {
                        color: colors.secondary_light,
                        '& span': {
                            fontWeight: 600,
                            fontSize: fontSizes.sm,
                            color: colors.text_header,
                        },
                    },
                },
            },
            MyAccount_DisclaimerCheckbox: {
                styleOverrides: {
                    label: {
                        display: 'none',
                    },
                },
            },
            MyAccount_TabContainer: {
                styleOverrides: {
                    tabs: {
                        marginBottom: 20,
                    },
                },
            },
            MyAccount_MiniWidgetButton: {
                styleOverrides: {
                    root: {
                        padding: '6px 0',
                        border: `2px solid ${colors.forth_dark}`,
                        width: 120,
                        color: colors.forth_dark,
                        fontSize: fontSizes.sm,
                    },
                    icon: {
                        width: 24,
                        height: 24,
                        fill: colors.forth_dark,
                    },
                    welcomeMessage: {
                        paddingRight: '5px',
                        color: colors.secondary_light,
                    },
                    buttonText: {
                        minWidth: 'max-content',
                        '&:hover': {
                            background: 'unset',
                        },
                    },
                },
            },
            MyAccount_MiniWidgetDropdownButton: {
                styleOverrides: {
                    iconButton: {
                        borderRadius: 'unset',
                        height: '72px',
                        width: '51px',
                        padding: '0px',
                        [`@media (max-width:${brandConstants.screens.md}px)`]: {
                            height: '48px',
                            padding: '6px',
                        },
                    },
                    loggedInIconButton: {
                        backgroundColor: colors.primary,
                        border: 'none',
                    },
                    loggedOutIconButton: {
                        border: 'none',
                        backgroundColor: colors.primary,
                    },
                    listIcon: {
                        fill: colors.white,
                        background: colors.primary,
                        borderRadius: '50%',
                        padding: '2px',
                    },
                    listLabel: {
                        fontSize: fontSizes.xs,
                        color: colors.white,
                        textTransform: 'uppercase',
                    },
                    menuItem: {
                        '&:hover': {
                            backgroundColor: colors.text_header,
                        },
                        minHeight: 40,
                        '&:not(:first-child):not(:last-child)': {
                            borderBottom: `1px solid ${colors.text_header}`,
                        },
                    },
                    welcomeMessage: {
                        color: colors.white,
                        fontWeight: 600,
                        backgroundColor: 'transparent',
                        textTransform: 'uppercase',
                        fontSize: fontSizes.xs,
                    },
                    menu: {
                        textAlign: 'center',
                        minWidth: 248,
                        backgroundColor: colors.primary,
                    },
                    divider: {
                        display: 'none',
                    },
                    image: {
                        backgroundColor: 'transparent',
                        height: '100%',
                        width: '100%',
                        marginBottom: '4px',
                        [`@media (max-width:${brandConstants.screens.md}px)`]: {
                            marginBottom: '2px',
                        },
                    },
                },
            },
            MyAccount_PasswordWidget: {
                styleOverrides: {
                    eyeIconButton: {
                        marginRight: 5,
                    },
                },
            },
            MyAccount_Login: {
                styleOverrides: {
                    container: {
                        paddingBottom: '40px',
                    },
                    loginModule: {
                        boxShadow: 'rgb(0 0 50 / 20%) 0px 2px 5px',
                    },
                },
            },
            MyAccount_MiniWidgetModal: {
                styleOverrides: {
                    modalRoot: {
                        [`@media (max-width:${brandConstants.screens.sm}px)`]: {
                            width: 'calc(100vw - 80px)',
                            height: ' calc(100vh - 160px)',
                            maxHeight: '500px;',
                        },
                    },
                    closeButton: {
                        width: '38px',
                        height: '38px',
                    },
                    icon: {
                        height: '38px',
                    },
                    content: {
                        '& > div': {
                            '& > .MuiGrid-root': {
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginBottom: '10px',
                                '& h4': {
                                    fontSize: fontSizes.md,
                                    fontWeight: 600,
                                    color: colors.dark_grey,
                                },
                                '& p': {
                                    color: colors.error,
                                    alignSelf: 'center',
                                    fontSize: fontSizes.xxs,
                                },
                            },
                        },
                    },
                },
            },
        },
    };
    return miniMyAccountBrandTheme;
};
export default buildMiniMyAccountBrandTheme;
//# sourceMappingURL=mini-my-account-brand-theme.js.map